import { getRumInstance } from "./singleton";

const rumInstance = getRumInstance();

export { init } from "./init";
export type { InitOptions } from "./types";
export const {
  addAction,
  addError,
  addTiming,
  clearUser,
  setUserProperty,
  removeUserProperty,
  setGlobalContextProperty,
  removeGlobalContextProperty,
  addFeatureFlagEvaluation,
  startDurationVital,
  stopDurationVital,
  setTrackingConsent,
} = rumInstance;

// These function reference the `this` object of the class so we have to call them from
// the rumInstance object instead of exporting it directly.

export const setUser = (
  // The types here a little weird because this method is overloaded and some of the overloads are
  // deprecated.
  newUser: Parameters<(typeof rumInstance)["setUser"]>[0] & {
    id: string;
  },
) => rumInstance.setUser(newUser);

export const startView: (typeof rumInstance)["startView"] = (...args) =>
  rumInstance.startView(...args);
